module.exports = __webpack_public_path__ + "img/answer_1.af283123.png";